import { Directive, Input } from '@angular/core';
import { AgGridColumnDef } from '../../../../common/ag-grid/ag-grid.component';

/**
 * Enum for entity assignment grid sides
 */
export enum EntityAssignmentGridSide {
  Left = 'left',
  Right = 'right'
}

/**
 * Directive for defining columns in entity assignment component
 * Extends AgGridColumnDef with additional columnFor property to specify which grid (left/right)
 */
@Directive({
  selector: '[entityAssignmentColumnDef]',
  standalone: false
})
export class EntityAssignmentColumnDef extends AgGridColumnDef {
  @Input('entityAssignmentColumnDef')
  override get id(): string {
    return this._id;
  }
  override set id(value: string) {
    this._id = value;
  }

  @Input() columnFor: EntityAssignmentGridSide;
}
